<template>
  <div class="col-md-12">
    <br />
    <form name="newDocument"
          class="form-horizontal form-label-left"
          @submit.prevent="handleSubmit()">
        <div class="item form-group">
            <label class="col-form-label col-md-3 col-sm-3 label-align">Company :</label>
            <div class="col-md-6 col-sm-6">
                <input v-validate="'max:50'"
                       name="Comapany"
                       v-model="encodingData.company"
                       class="form-control"
                       :class="{ 'is-invalid': submitted && errors.has('Company')}" />
                <div v-if="submitted && errors.has('Company')" class="invalid-feedback">
                    {{ errors.first("Company") }}
                </div>
            </div>
        </div>

        <div class="item form-group">
            <label class="col-form-label col-md-3 col-sm-3 label-align">Type :</label>
            <div class="col-md-6 col-sm-6">
                <select name="financialttype" v-model="encodingData.Type" class="form-control" :class="{ 'is-invalid': submitted && errors.has('financialttype') }">
                  <option value>Select Type</option>
                    <option v-for="option in types"
                            v-bind:value="option.financialTypeID_"
                            v-bind:key="option.financialTypeID_">
                        {{ option.financialType }}
                    </option>
                </select>
                <div v-if="submitted && errors.has('financialttype')"
                         class="invalid-feedback">
                        {{ errors.first("financialttype") }}
                    </div>
            </div>
        </div>

        <div class="item form-group">
            <label class="col-form-label col-md-3 col-sm-3 label-align">Account Number :</label>
            <div class="col-md-6 col-sm-6">
                <input v-validate="'required|max:50'"
                       name="AccountNo"
                       v-model="encodingData.AccountNo"
                       class="form-control"
                       :class="{ 'is-invalid': submitted && errors.has('AccountNo') }" />
                <div v-if="submitted && errors.has('AccountNo')"
                     class="invalid-feedback">
                    {{ errors.first("AccountNo") }}
                </div>
            </div>
        </div>

        <div class="item form-group">
            <label class="col-form-label col-md-3 col-sm-3 label-align">Comments :</label>
            <div class="col-md-6 col-sm-6">
                <textarea name="Comments"
                          v-model="encodingData.Comments"
                          rows="5"
                          cols="5"
                          class="form-control" />
            </div>
        </div>

        <div class="item form-group">
            <label class="col-form-label col-md-3 col-sm-3 label-align">Country:</label>
            <div class="col-md-6 col-sm-6">
                <select name="Country"
                        v-model="encodingData.Country"
                        class="form-control">
                    <option value>Select Country</option>
                    <option v-for="option in countries"
                            v-bind:value="option.countryName"
                            v-bind:key="option.countryName">
                        {{ option.countryName }}
                    </option>
                </select>
            </div>
        </div>

        <div class="item form-group">
            <label class="col-form-label col-md-3 col-sm-3 label-align">State:</label>
            <div class="col-md-6 col-sm-6">
                <select name="SourceId"
                        v-model="encodingData.State"
                        class="form-control"
                        >
                    <option value>Select State</option>
                    <option v-for="option in provinces"
                            v-bind:value="option.province"
                            v-bind:key="option.province">
                        {{ option.province }}
                    </option>
                </select>
            </div>
        </div>
        <div class="item form-group">
            <label class="col-form-label col-md-3 col-sm-3 label-align">City :</label>
            <div class="col-md-6 col-sm-6">
                <input type="text"
                       name="City"
                       v-model="encodingData.City"
                       class="form-control" />
            </div>
        </div>

        <div class="ln_solid"></div>
        <div class="item form-group">
            <div class="col-md-6 col-sm-6">
                <button type="submit" class="btn btn-primary">Save</button>&nbsp;
                <button type="button" v-on:click="clearControls()" class="btn btn-primary">Clear</button>
            </div>
        </div>
    </form>
    <b-modal id="LinkPopFR" title="Link Builder" scrollable hide-footer>
      <LinkPopUp />
    </b-modal>
  </div>
</template>

<script>
import {
  authHeader,
  responseCheck,
  notifyHelper,
  EncodeURL,
  getlocalstorageCountry,
  getlocalstorageProvince,
  checkLinkMode,
  setObject2Link,
  getLocalstorageFinancialTypes
} from "../../helper";
import LinkPopUp from "../master/Linking";
import instance from "../../helper/http";
export default {
  data() {
    return {
      encodingData: {
        Company: "",
        Type: "",
        AccountNo: "",
        Comments: "",
        Country: "",
        State: "",
        City: "",
      },
      countries: [],
      provinces: [],
      types: []
    };
  },
  components: {
    LinkPopUp,
  },
  methods: {
    handleSubmit() {
      let loader = this.$loading.show();
      instance
        .post(EncodeURL + "newfinancial", this.encodingData, {
          headers: authHeader(),
        })
        .then((response) => {
          if (response.data.error) {
            loader.hide();
            notifyHelper(
              "error",
              "There was an error processing your request!"
            );
          } else {
            loader.hide();
            notifyHelper("success", "Saved");
            //this.clearControls()
            if (checkLinkMode()) {
              if (confirm("Link this newly created entity?")) {
                setObject2Link(response.data.id, "FR");
                this.setLink(response.data.id);
              }
            }
          }
        })
        .catch(function (error) {
          loader.hide();
          responseCheck(error.response.status);
        });
    },
    getlibs() {
      this.countries = getlocalstorageCountry();
      this.provinces = getlocalstorageProvince();
      this.types = getLocalstorageFinancialTypes();
    },
    setLink: function (id) {
      setObject2Link(id, "FR");
      this.$bvModal.show("LinkPopFR");
    },
    clearControls() {
      
      this.encodingData.Company = "";
      this.encodingData.Type = "";
      this.encodingData.AccountNo = "";
      this.encodingData.Comments = "";
      this.encodingData.Country = "";
      this.encodingData.State = "";
      this.encodingData.City = "";
    },
  },
  created: function () {
    this.getlibs();
  },
};
</script>

